const isSupportEs6 = function() {
  try {
    new Function('(a = 0) => a');
    return true;
  } catch (err) {
    return false;
  }
};

export default isSupportEs6;
